var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home"},[_c('home-banner',{style:({
      backgroundImage: `url(${_vm.bannerBg})`,
      backgroundSize: '100% 100%',
    })}),_c('home-procurement'),_c('home-want-buy'),_c('home-news')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }